import {useMediaQuery} from '@mui/material'
import {FC, useState} from 'react'
import {Account} from './account'
import {Billing} from './billing'
import {SettingsSidebarId} from './config'
import {Deactivation} from './deactivation'
import {EditProfile} from './editProfile'
import {Notifications} from './notifications'
import styles from './styles.module.scss'
import {SettingsMobile} from './ui/settingsMobile'
import {SettingsSidebar} from './ui/settingsSidebar'

export const SettingsPage: FC = () => {
  const [selectedId, setSelectedId] = useState(SettingsSidebarId.EDIT_PROFILE)
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)

  if (is768p) {
    return (
      <SettingsMobile />
    )
  }

  return (
    <div className={styles.settingsWrapper}>
      <div className={styles.settings}>
        <SettingsSidebar selectedId={selectedId} onClickItem={setSelectedId} />
        <div className={styles.settings__content}>
          <Content itemId={selectedId} />
        </div>
      </div>
    </div>
  )
}

type ContentProps = {
  itemId: SettingsSidebarId
}

const Content: FC<ContentProps> = ({itemId}) => {
  switch (itemId) {
  case SettingsSidebarId.EDIT_PROFILE:
    return <EditProfile />
  case SettingsSidebarId.ACCOUNT:
    return <Account />
  case SettingsSidebarId.NOTIFICATIONS:
    return <Notifications />
  case SettingsSidebarId.BILLING:
    return <Billing />
  case SettingsSidebarId.DEACTIVATION:
    return <Deactivation />
  }
}
